import { useMutation } from '@tanstack/react-query';

import { RestApiError } from 'services/api/restful/errors';
import { acceptTransfer } from 'services/api/restful/generated/tickets/tickets';

type TransferAcceptVariables = {
  transferId: string;
  version: number;
};

export const useTransferAccept = () => {
  const { mutate, isPending, isPaused } = useMutation<
    void,
    RestApiError,
    TransferAcceptVariables
  >({
    mutationFn: async ({ transferId, version }) => {
      await acceptTransfer(transferId, { version });
    },
    retry: false,
  });

  return {
    acceptTransfer: mutate,
    isLoading: isPending && !isPaused,
  };
};
